import React from 'react'

import { type CoreCustomer } from '@flecto/types'
import { DataTable, type DataTableProps } from '@flecto/ui'

import { useDrawerCustomer } from '../DrawerCustomer/useDrawerCustomer'
import { useColumns } from './useColumns'

type TableCustomersProps = Omit<DataTableProps<CoreCustomer>, 'columns'> & {
  customers?: CoreCustomer[]
  isLoading?: boolean
}

export function TableCustomers({
  customers,
  isLoading,
  ...props
}: TableCustomersProps) {
  const columns = useColumns()

  const [selectedCustomer, setSelectedCustomer] = React.useState<
    Partial<CoreCustomer> | undefined
  >(undefined)
  const { openDrawer } = useDrawerCustomer({
    customer: selectedCustomer,
    setCustomer: setSelectedCustomer,
  })

  React.useEffect(() => {
    if (selectedCustomer) {
      openDrawer()
    }
  }, [selectedCustomer, openDrawer])

  return (
    <DataTable
      {...props}
      records={customers}
      columns={columns}
      isLoading={isLoading}
      highlightOnHover
    />
  )
}
